import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

/**
 * Layered animated emerald blobs used across the site. Position via className.
 */
export const BlobField = ({ variant = "hero", className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [0, -80]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, 60]);

  if (variant === "hero") {
    return (
      <div ref={ref} className={`pointer-events-none absolute inset-0 -z-10 overflow-hidden ${className}`}>
        <motion.div
          style={{ y: y1 }}
          className="blob blob-slow"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.75 }}
          transition={{ duration: 1.6, ease: [0.22, 0.61, 0.36, 1] }}
        >
          <div
            className="w-[62vw] h-[62vw] max-w-[900px] max-h-[900px]"
            style={{
              background:
                "radial-gradient(closest-side, #00D084 0%, rgba(0,208,132,0.45) 45%, rgba(6,95,70,0) 75%)",
              borderRadius: "42% 58% 62% 38% / 44% 40% 60% 56%",
              transform: "translate(-20%, -30%)",
            }}
          />
        </motion.div>
        <motion.div
          style={{ y: y2 }}
          className="blob blob-fast"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.55 }}
          transition={{ duration: 2, delay: 0.3, ease: [0.22, 0.61, 0.36, 1] }}
        >
          <div
            className="absolute right-[-10%] top-[20%] w-[46vw] h-[46vw] max-w-[720px] max-h-[720px]"
            style={{
              background:
                "radial-gradient(closest-side, #10B981 0%, rgba(16,185,129,0.35) 40%, rgba(0,0,0,0) 75%)",
              borderRadius: "62% 38% 46% 54% / 34% 62% 38% 66%",
            }}
          />
        </motion.div>
        <motion.div
          className="blob"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.4 }}
          transition={{ duration: 2.4, delay: 0.5, ease: "easeOut" }}
        >
          <div
            className="absolute left-[35%] bottom-[-20%] w-[40vw] h-[40vw] max-w-[600px] max-h-[600px]"
            style={{
              background:
                "radial-gradient(closest-side, #065F46 0%, rgba(6,95,70,0.35) 45%, rgba(0,0,0,0) 75%)",
              borderRadius: "38% 62% 52% 48% / 60% 44% 56% 40%",
            }}
          />
        </motion.div>
      </div>
    );
  }

  // Ambient variant — softer, single blob
  return (
    <div ref={ref} className={`pointer-events-none absolute inset-0 -z-10 overflow-hidden ${className}`}>
      <motion.div style={{ y: y1 }} className="blob blob-slow">
        <div
          className="absolute left-[10%] top-[30%] w-[50vw] h-[50vw] max-w-[720px] max-h-[720px]"
          style={{
            background:
              "radial-gradient(closest-side, rgba(0,208,132,0.45) 0%, rgba(16,185,129,0.15) 45%, rgba(0,0,0,0) 75%)",
            borderRadius: "50% 50% 40% 60% / 45% 55% 45% 55%",
            opacity: 0.7,
          }}
        />
      </motion.div>
    </div>
  );
};
